import React, { useEffect, useState } from 'react'
import ReactApexChart from 'react-apexcharts';


const DonutCharts = ({taskSummary}) => {

    useEffect(()=>{
        setSeries([ taskSummary?.score , taskSummary?.wrongAttempts ])
    },[taskSummary])

    const [series, setSeries] = useState([0, 100]);
    const [options] = useState({
        chart: {
            height: 100,
            type: 'donut',
        },
        dataLabels: {
            enabled: false,
        },
        responsive: [
            {
                breakpoint: 480,
                options: {
                    legend: {
                        show: false,
                    },
                },
            },
        ],
        legend: {
            show: false,
            position: 'right',
            offsetY: 0,
        },
        stroke: {
            color: 'none',
            width: 0
        },
        labels: ['Correct Attempt', 'Wrong Attempt'],
        colors: ['#247bc0', '#3e4095'],
    });

    return (
        <>
            <div className='position-relative'>
                <ReactApexChart
                    options={options}
                    series={series}
                    type="donut"
                    width="80px"
                    height="100px"
                />
                <p className='pscroe'> { taskSummary?.score } </p>
            </div>
        </>
    )
}

export default DonutCharts
